/**
 * @file components/Bulletpoint/component.js
 * @copyright 2019 CBC/Radio-Canada. All rights reserved.
 * @author Abby Christens [abby.christens@cbc.ca]
 */

export default function Bulletpoint(props) {
    return (
        <li className="bulletpoint" data-testid="bulletpoint">
            {props.text}
        </li>
    );
}
